<template>
  <Loading class="flex flex-col flex-grow" :loading="waitPending">
    <div class="flex-grow">
      <Table
        :columns="columns"
        :rows="transactions"
        :busy="waitPending"/>
    </div>
    <div class="flex flex-row items-end justify-center p-6">
      <Pagination
        :page="page"
        :page-count="pageCount"
        @change="onPageChange"/>
    </div>
  </Loading>
</template>

<script type="text/jsx">
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Table from '@/components/Table.vue';
import Pagination from '@/components/Pagination.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import Attachment from '@/components/global/Attachment.vue';
import Loading from '@/components/Loading.vue';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    Table,
    Pagination,
    Loading,
  },
  data() {
    return {
      limit: 100,
      page: 1,
      transactionTypes: {
        DEPOSIT_CONTRACTOR: 'Пополнение счета',
        DEPOSIT_CONTRACTOR_ORDER: 'Выплаты за заказ',
        WITHDRAW_CONTRACTOR: 'Вывод средств ',
        WITHDRAW_CONTRACTOR_PENALTY: 'Штраф ',
        WITHDRAW_CONTRACTOR_ASSIGN: 'Списание за взятие заказа ',
        DEPOSIT_ACQUIRING_CONTRACTOR: 'Пополнение личного счета',
        WITHDRAW_CUSTOMER: 'Оплата за заказ',
        WITHDRAW_CUSTOMER_ORDER: 'Оплата за заказ',
        REFUND_CUSTOMER: 'Возврат средств',
        DEPOSIT_CUSTOMER: '',
        DEPOSIT_CUSTOMER_ORDER: '',
        DEPOSIT_ACQUIRING_CUSTOMER: 'Оплата за платную отмену заказа',
      },
    };
  },
  computed: {
    ...mapGetters({
      payload: 'contractors/transactions',
    }),
    columns() {
      return [
        {
          label: '№',
          field: 'id',
          tdClass: 'font-bold',
          sortable: false,
        },
        {
          label: 'Сумма',
          field: 'amount',
          sortable: false,
          cell: ({ row }) => <b>{ this.$numeral(parseFloat(row.amount)).format('0,0 $') }</b>,
        },
        {
          label: 'Транзакция',
          field: 'type',
          cell: ({ row }) => <div>{ row.transactionType }</div>,
          sortable: false,
        },
        {
          label: 'Номер заказа',
          field: 'orderId',
          sortable: false,
          cell: ({ row }) => {
            if (row.order) {
              return <div class="flex flex-col items-start cursor-pointer" onClick={() => {
                this.$router.push({
                  name: 'orders.info',
                  params: {
                    id: row.order.id,
                  },
                });
              }}>
                <b>{ row.order.name }</b>
                <StatusBadge status={row.order.state}/>
              </div>;
            }
            return null;
          },
        },
        {
          label: 'Услуга',
          field: 'firstServiceCategoryId',
          cell: ({ row }) => {
            const id = _.get(row, 'order.firstServiceCategory.iconAttach');
            if (typeof id !== 'undefined') {
              return <Attachment class="w-6 h-6 object-center object-contain" id={id}/>;
            }
            return null;
          },
          sortable: false,
        },
        {
          label: 'Дата создания транзакции',
          field: 'createdAt',
          sortable: false,
          cell: ({ row }) => <div>
            { this.$moment(row.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY') }
          </div>,
        },
      ];
    },
    transactions() {
      const data = _.get(this.payload(this.id), 'data') || [];
      return data.map((transaction) => {
        const foundType = _.get(this.transactionTypes, transaction.type.toUpperCase());
        // eslint-disable-next-line no-param-reassign
        transaction.transactionType = foundType || transaction.type.toUpperCase();
        if (transaction.order) {
          const firstServiceCategory = _.get(transaction.order, 'services.[0].service.category');
          // eslint-disable-next-line no-param-reassign
          transaction.order = {
            ...transaction.order,
            firstServiceCategory,
          };
          if (firstServiceCategory) {
            // eslint-disable-next-line no-param-reassign
            transaction.order.name = `${firstServiceCategory.abbreviation}-${transaction.order.id}`;
          }
        }
        return transaction;
      });
    },
    offset() {
      return (this.page - 1) * this.limit;
    },
    total() {
      return _.get(this.payload(this.id), 'total') || 0;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    waitKey() {
      return `fetch.contractor.transactions.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
  },
  methods: {
    ...mapActions({
      fetch: 'contractors/ACT_FETCH_CONTRACTOR_TRANSACTIONS',
    }),
    onPageChange(event) {
      this.page = event;
    },
    fetchPayload() {
      this.fetch({
        id: this.id,
        limit: this.limit,
        offset: this.offset,
      });
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.fetchPayload();
    });
    this.$watch((that) => [that.page], () => {
      this.fetchPayload();
    });
  },
};
</script>
